<template>
  <div>
    <div class="row">
      <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
      </loading>
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th width="5%">#</th>
                <th width="15%">Data</th>
                <th width="25%">Tipo</th>
                <th width="20%">Observação</th>
                <th width="20%">Análise IA</th>
                <th width="15%">#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="attachment in attachments" :key="attachment.id">
                  <td><input type="checkbox" v-model="attachment.checked" v-if="attachment.user_operator_id"></td>
                  <td class="font-size-12">{{ $moment(attachment.created_at).format('DD/MM/YYYY HH:mm') }}</td>
                  <td>
                    {{ types[attachment.type] }}
                    <span class="badge badge-pill font-size-12" :class="{
                      'badge-soft-primary': !attachment.user_operator_id,
                      'badge-soft-success': attachment.user_operator_id
                    }">{{ !attachment.user_operator_id ? 'RECEBIDO' : 'ANEXADO' }}</span>
                  </td>
                  <td>
                    <i v-if="isUserAdmin || isUserMaster" class="bx bx-edit-alt font-size-15 link" @click="openObs(attachment)"></i>
                    <textarea class="form-control" v-if="editObs" v-model="attachment.obs"></textarea>
                     {{ attachment.obs }}
                  </td>
                  <!-- Coluna Análise IA -->
                  <td>
                    <!-- Sem análise -->
                    <a
                      v-if="!attachment.analysis_status"
                      href="javascript:void(0)"
                      class="ai-analyze-btn"
                      @click="startAnalysis(attachment)"
                      :class="{ 'disabled': analyzingIds.includes(attachment.id) }"
                    >
                      <i class="bx bxs-magic-wand"></i>
                      <span>Analisar com IA</span>
                    </a>

                    <!-- Processando -->
                    <div v-else-if="attachment.analysis_status === 'pending' || attachment.analysis_status === 'processing'" class="ai-progress-wrapper">
                      <div class="ai-progress-info">
                        <span class="ai-pulse"></span>
                        <span class="font-size-11">{{ progressStage(attachment.id) }}</span>
                        <span class="font-size-11 font-weight-bold ml-auto">{{ progressPercent(attachment.id) }}%</span>
                      </div>
                      <div class="ai-progress-bar">
                        <div class="ai-progress-fill" :style="{ width: progressPercent(attachment.id) + '%' }"></div>
                      </div>
                    </div>

                    <!-- Completada - válido -->
                    <a v-else-if="attachment.analysis_status === 'completed' && attachment.analysis_overall === 'valid'" href="javascript:void(0)" class="ai-result ai-result--valid" @click="openAnalysis(attachment)">
                      <i class="bx bx-check-circle"></i>
                      <span>Validado</span>
                      <span v-if="attachment.has_applied_data" class="ai-applied-dot" title="Dados aplicados"></span>
                    </a>

                    <!-- Completada - alertas -->
                    <a v-else-if="attachment.analysis_status === 'completed' && attachment.analysis_overall === 'warnings'" href="javascript:void(0)" class="ai-result ai-result--warnings" @click="openAnalysis(attachment)">
                      <i class="bx bx-error"></i>
                      <span>Alertas</span>
                      <span v-if="attachment.has_applied_data" class="ai-applied-dot" title="Dados aplicados"></span>
                    </a>

                    <!-- Completada - inválido -->
                    <a v-else-if="attachment.analysis_status === 'completed' && attachment.analysis_overall === 'invalid'" href="javascript:void(0)" class="ai-result ai-result--invalid" @click="openAnalysis(attachment)">
                      <i class="bx bx-x-circle"></i>
                      <span>Divergências</span>
                      <span v-if="attachment.has_applied_data" class="ai-applied-dot" title="Dados aplicados"></span>
                    </a>

                    <!-- Completada - sem overall definido (fallback) -->
                    <a v-else-if="attachment.analysis_status === 'completed'" href="javascript:void(0)" class="ai-result ai-result--neutral" @click="openAnalysis(attachment)">
                      <i class="bx bx-search-alt"></i>
                      <span>Ver Resultado</span>
                      <span v-if="attachment.has_applied_data" class="ai-applied-dot" title="Dados aplicados"></span>
                    </a>

                    <!-- Falhou -->
                    <span v-else-if="attachment.analysis_status === 'failed'" class="d-inline-flex align-items-center">
                      <span class="ai-result ai-result--failed">
                        <i class="bx bx-error-alt"></i>
                        <span>Falhou</span>
                      </span>
                      <a
                        href="javascript:void(0)"
                        class="ai-retry-btn ml-2"
                        @click="retryAttachmentAnalysis(attachment)"
                        :class="{ 'disabled': analyzingIds.includes(attachment.id) }"
                        title="Tentar novamente"
                      >
                        <i class="bx bx-refresh"></i>
                      </a>
                    </span>
                  </td>
                  <td>
                    <a :href="attachment.document" target="_blank" class="link">
                      <button type="button" class="btn btn-outline-secondary btn-sm">Ver</button>
                    </a>
                    <span class="link ml-1">
                      <button type="button" class="btn btn-outline-dark btn-sm" @click="downloadFile(attachment)">Baixar</button>
                    </span>
                    <button v-if="attachment.user_operator_id" type="button" @click="deleteAttachment(attachment)" class="link ml-1 btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button>
                  </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <b-button v-if="hasAttachmentByOperator && (isUserAdmin || isUserMaster)" variant="outline-success" size="sm" @click="sendAttachment()">Enviar via E-mail</b-button>
      <b-button variant="outline-primary" class="dotted ml-2" size="sm" @click="openForm()" v-if="isUserAdmin || isUserMaster">Adicionar anexo</b-button>
    </div>
    <form-attachment :idParticipant="idParticipant" v-model="modalForm" ref="uploadAttachment" @createdAttachment="updateList"></form-attachment>
    <edit-attachment v-model="modalEdit" ref="editAttachment" @updatedAttachment="updateList"></edit-attachment>
    <analysis-result-modal
      v-model="modalAnalysis"
      :attachmentId="selectedAttachmentId"
      :participantId="idParticipant"
      @applied="onAnalysisApplied"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Swal from 'sweetalert2'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapGetters, mapState } from 'vuex'
import FormAttachment from './FormUpload'
import EditAttachment from './EditAttachment'
import AnalysisResultModal from './AnalysisResultModal'

export default {
  components: {
    Loading,
    FormAttachment,
    EditAttachment,
    AnalysisResultModal
  },
  props: {
    idParticipant: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      attachments: [],
      submitted: false,
      editObs: false,
      showFormAttachment: false,
      statusClass: ['dark', 'primary', 'warning', 'success', 'danger'],
      modalForm: false,
      modalEdit: false,
      modalAnalysis: false,
      selectedAttachmentId: null,
      analyzingIds: [],
      pollingInterval: null,
      progressMap: {},
      progressTimers: {}
    }
  },
  mounted () {
    this.GetAttachmentType()
  },
  beforeMount () {
    this.GetAttachments(this.idParticipant).then((res) => {
      this.attachments = res.data
      this.loading = false
      this.startPollingIfNeeded()
      this.syncProgressWithAttachments()
    }).catch(error => {
      console.log(error)
      this.loading = false
    })
  },
  beforeDestroy () {
    this.stopPolling()
    Object.keys(this.progressTimers).forEach(id => {
      clearInterval(this.progressTimers[id])
    })
  },
  methods: {
    ...mapActions('participant', {
      GetAttachments: 'getAllAttachments',
      destroyAttachment: 'delAttachment',
      sendEmailAttachment: 'sendEmailAttach',
      doAnalyze: 'analyzeAttachment',
      doRetry: 'retryAnalysis'
    }),
    ...mapActions('settings', {
      GetAttachmentType: 'GetAttachmentType'
    }),
    async downloadFile (attachment) {
      try {
        this.loading = true
        const url = attachment.document
        const extension = url.split('.').pop().toLowerCase()
        const participantName = this.participantName || 'Participante'
        const attachmentType = this.types[attachment.type]
        const fileName = `${participantName}_${attachmentType}.${extension}`
        const response = await fetch(url)
        const blob = await response.blob()
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
        this.loading = false
      } catch (error) {
        console.error('Erro ao baixar o arquivo:', error)
        errorMessage('Alerta: Não foi possível baixar o arquivo.')
        this.loading = false
      }
    },
    openForm () {
      this.$refs.uploadAttachment.open(this.participantId)
      this.modalForm = true
    },
    openObs (attachment) {
      this.$refs.editAttachment.open(attachment)
      this.modalEdit = true
    },
    deleteAttachment (attachment) {
      Swal.fire({
        title: 'Você tem certeza?',
        html: `Será excluído o anexo: <b>${this.types[attachment.type]}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#eb0101',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyAttachment(attachment.id).then((res) => {
              successMessage('Sucesso: Anexo removido.', 2500)
            }).then(() => {
              this.updateList()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    sendAttachment () {
      const attachments = this.attachments.filter(o => o.checked === true)
      let list = ''
      attachments.map((a, i) => {
        list += `<li><b>${this.types[a.type]}</b></li>`
      })
      Swal.fire({
        title: 'Você tem certeza?',
        html: `Será enviado via e-mail os itens abaixo: <br /> ${list}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#388741',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, ENVIAR E-MAIL!'
      }).then(result => {
        if (result.value) {
          try {
            this.sendEmailAttachment({ id: this.idParticipant, attachments: attachments }).then((res) => {
              successMessage('Sucesso: E-mail enviado.', 2500)
            }).then(() => {
              this.updateList()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    updateList () {
      this.GetAttachments(this.idParticipant).then((res) => {
        this.attachments = res.data
        this.loading = false
        this.startPollingIfNeeded()
        this.syncProgressWithAttachments()
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    // ── Progress Simulation ──
    progressPercent (id) {
      return (this.progressMap[id] && this.progressMap[id].percent) || 0
    },
    progressStage (id) {
      return (this.progressMap[id] && this.progressMap[id].stage) || 'Iniciando...'
    },
    startProgress (id) {
      const stages = [
        { at: 5, stage: 'Iniciando análise...' },
        { at: 15, stage: 'Baixando documento...' },
        { at: 25, stage: 'Processando imagem...' },
        { at: 40, stage: 'Extraindo dados...' },
        { at: 55, stage: 'Analisando conteúdo...' },
        { at: 70, stage: 'Comparando cadastro...' },
        { at: 80, stage: 'Validando informações...' },
        { at: 90, stage: 'Finalizando...' }
      ]
      this.$set(this.progressMap, id, { percent: 0, stage: 'Iniciando...' })
      let step = 0
      const timer = setInterval(() => {
        if (step < stages.length) {
          this.$set(this.progressMap, id, { percent: stages[step].at, stage: stages[step].stage })
          step++
        } else {
          // After all stages, slowly creep toward 95
          const cur = this.progressMap[id].percent
          if (cur < 95) {
            this.$set(this.progressMap, id, { percent: cur + 1, stage: 'Finalizando...' })
          }
        }
      }, 2500)
      this.$set(this.progressTimers, id, timer)
    },
    stopProgress (id) {
      if (this.progressTimers[id]) {
        clearInterval(this.progressTimers[id])
        this.$delete(this.progressTimers, id)
      }
      this.$delete(this.progressMap, id)
    },
    syncProgressWithAttachments () {
      // Start progress for any pending/processing without a timer
      this.attachments.forEach(a => {
        if ((a.analysis_status === 'pending' || a.analysis_status === 'processing') && !this.progressTimers[a.id]) {
          this.startProgress(a.id)
        }
      })
      // Stop progress for any that are no longer pending/processing
      Object.keys(this.progressTimers).forEach(id => {
        const att = this.attachments.find(a => String(a.id) === String(id))
        if (!att || (att.analysis_status !== 'pending' && att.analysis_status !== 'processing')) {
          this.stopProgress(id)
        }
      })
    },
    // ── Document Intelligence ──
    async startAnalysis (attachment) {
      try {
        this.analyzingIds.push(attachment.id)
        await this.doAnalyze(attachment.id)
        successMessage('Análise iniciada! Aguarde o processamento.', 2500)
        this.startProgress(attachment.id)
        this.updateList()
      } catch (err) {
        const msg = err.response?.data?.message || err.message
        errorMessage('Erro ao iniciar análise: ' + msg)
      } finally {
        this.analyzingIds = this.analyzingIds.filter(id => id !== attachment.id)
      }
    },
    async retryAttachmentAnalysis (attachment) {
      try {
        this.analyzingIds.push(attachment.id)
        await this.doRetry(attachment.id)
        successMessage('Reprocessamento iniciado!', 2500)
        this.startProgress(attachment.id)
        this.updateList()
      } catch (err) {
        const msg = err.response?.data?.message || err.message
        errorMessage('Erro ao reprocessar: ' + msg)
      } finally {
        this.analyzingIds = this.analyzingIds.filter(id => id !== attachment.id)
      }
    },
    openAnalysis (attachment) {
      this.selectedAttachmentId = attachment.id
      this.modalAnalysis = true
    },
    onAnalysisApplied () {
      this.updateList()
      this.$emit('dataApplied')
    },
    // ── Polling ──
    startPollingIfNeeded () {
      const hasPending = this.attachments.some(
        a => a.analysis_status === 'pending' || a.analysis_status === 'processing'
      )

      if (hasPending && !this.pollingInterval) {
        this.pollingInterval = setInterval(() => {
          this.GetAttachments(this.idParticipant).then((res) => {
            this.attachments = res.data
            const stillPending = this.attachments.some(
              a => a.analysis_status === 'pending' || a.analysis_status === 'processing'
            )
            if (!stillPending) {
              this.stopPolling()
              this.$emit('dataApplied')
            }
          }).catch(() => {})
        }, 5000)
      } else if (!hasPending) {
        this.stopPolling()
      }
    },
    stopPolling () {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
        this.pollingInterval = null
      }
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('settings', { types: 'ATTACHMENTTYPE' }),
    ...mapState('participant', ['participant']),
    participantName () {
      return this.participant?.name || 'Participante'
    },
    hasAttachmentByOperator () {
      return this.attachments.filter(o => o.user_operator_id > 0).length
    },
    isUserAdmin () {
      return this.$store.getters['auth/isAdmin']
    },
    isUserMaster () {
      return this.$store.getters['auth/isMaster']
    }
  }
}
</script>
<style scoped>
.dotted { border: 1px dotted #556ee6 !important}
.link { cursor: pointer; }

/* ── AI Analyze Button ── */
.ai-analyze-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #556ee6;
  background: rgba(85, 110, 230, 0.08);
  border: 1px dashed rgba(85, 110, 230, 0.4);
  text-decoration: none;
  transition: all 0.2s ease;
}
.ai-analyze-btn:hover {
  background: rgba(85, 110, 230, 0.15);
  border-color: #556ee6;
  color: #556ee6;
  text-decoration: none;
}
.ai-analyze-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.ai-analyze-btn i {
  font-size: 14px;
}

/* ── AI Progress ── */
.ai-progress-wrapper {
  min-width: 140px;
  max-width: 180px;
}
.ai-progress-info {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 4px;
  color: #c48d1a;
}
.ai-pulse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #f1b44c;
  flex-shrink: 0;
  animation: ai-pulse-anim 1.2s ease-in-out infinite;
}
@keyframes ai-pulse-anim {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(0.7); }
}
.ai-progress-bar {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: rgba(241, 180, 76, 0.15);
  overflow: hidden;
}
.ai-progress-fill {
  height: 100%;
  border-radius: 2px;
  background: linear-gradient(90deg, #f1b44c, #f0ad4e);
  transition: width 0.8s ease;
}

/* ── AI Result Badges ── */
.ai-result {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.15s ease;
  position: relative;
}
.ai-result:hover { text-decoration: none; }
.ai-result i { font-size: 14px; }

.ai-result--valid {
  color: #34c38f;
  background: rgba(52, 195, 143, 0.1);
}
.ai-result--valid:hover { background: rgba(52, 195, 143, 0.18); color: #34c38f; }

.ai-result--warnings {
  color: #c48d1a;
  background: rgba(241, 180, 76, 0.1);
}
.ai-result--warnings:hover { background: rgba(241, 180, 76, 0.18); color: #c48d1a; }

.ai-result--invalid {
  color: #f46a6a;
  background: rgba(244, 106, 106, 0.1);
}
.ai-result--invalid:hover { background: rgba(244, 106, 106, 0.18); color: #f46a6a; }

.ai-result--neutral {
  color: #74788d;
  background: rgba(116, 120, 141, 0.1);
}
.ai-result--neutral:hover { background: rgba(116, 120, 141, 0.18); color: #74788d; }

.ai-result--failed {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #f46a6a;
  background: rgba(244, 106, 106, 0.1);
}

/* ── Applied Dot ── */
.ai-applied-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #556ee6;
  margin-left: 2px;
  flex-shrink: 0;
}

/* ── Retry Button ── */
.ai-retry-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  color: #f1b44c;
  background: rgba(241, 180, 76, 0.1);
  text-decoration: none;
  transition: all 0.15s ease;
}
.ai-retry-btn:hover {
  background: rgba(241, 180, 76, 0.2);
  color: #f1b44c;
  text-decoration: none;
}
.ai-retry-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.ai-retry-btn i { font-size: 16px; }
</style>
